/** Weekdays use the backend convention: Monday = 1, Sunday = 7. */
export function parseWorkingWeekDays(value: unknown): number[] {
    const fallback = [1, 2, 3, 4, 5, 6, 7];
    if (typeof value !== 'string' || !value.trim()) return fallback;
    const parts = value.split(',').map(day => day.trim());
    if (parts.some(day => !/^[1-7]$/.test(day))) return fallback;
    return [...new Set(parts.map(Number))];
}
